import React from "react";
class ContestHeader extends React.Component {
  render() {
    return (
      <>
        <div
          className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style={{
            minHeight: "450px",
            backgroundImage:
              "url(" + require("../../assets/img/greenpuja/durga_puja_banner.jpeg") + ")",
            backgroundSize: "cover",
            backgroundPosition: "center top"
          }} 
        >   
        
        </div>
      </>
    );
  }
}

export default ContestHeader;
